import { Heading, VFlow } from 'bold-ui'

import { TransmissaoLinksDestinoTable } from './TransmissaoLinksDestinoTable'

export const TransmissaoLinksDestinoBox = () => {
  return (
    <VFlow vSpacing={0.5}>
      <Heading level={3}>Instalações de destino para envio online</Heading>

      <TransmissaoLinksDestinoTable />
    </VFlow>
  )
}
